var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2375_4269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H100V100H0V0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5.75H34V33.75H6V5.75ZM20.525 31.5917L20.2625 26.5575C20.2587 26.4747 20.2735 26.3921 20.3058 26.3158C20.3381 26.2395 20.3872 26.1714 20.4493 26.1166C20.5114 26.0617 20.5851 26.0215 20.6648 25.9989C20.7445 25.9762 20.8283 25.9718 20.91 25.9858L25.9208 26.8667L25.2442 25C25.2167 24.9257 25.2132 24.8447 25.2341 24.7684C25.255 24.692 25.2994 24.6241 25.3608 24.5742L30.85 20.1292L29.6133 19.5517C29.5298 19.5122 29.4636 19.4436 29.4271 19.3587C29.3905 19.2739 29.3862 19.1786 29.415 19.0908L30.5 15.7542L27.3383 16.425C27.2527 16.4429 27.1635 16.4305 27.0859 16.3901C27.0083 16.3497 26.947 16.2837 26.9125 16.2033L26.3 14.7625L23.8325 17.4108C23.7761 17.4703 23.7019 17.51 23.621 17.5237C23.5402 17.5375 23.4571 17.5247 23.3841 17.4873C23.3112 17.4498 23.2523 17.3897 23.2164 17.316C23.1805 17.2422 23.1695 17.1589 23.185 17.0783L24.375 10.9417L22.4675 12.0442C22.4227 12.0704 22.373 12.0872 22.3215 12.0934C22.27 12.0997 22.2177 12.0953 22.1679 12.0805C22.1182 12.0658 22.072 12.041 22.0322 12.0076C21.9924 11.9743 21.9599 11.9331 21.9367 11.8867L20 8.08333L18.0633 11.8867C18.0401 11.9331 18.0076 11.9743 17.9678 12.0076C17.928 12.041 17.8818 12.0658 17.8321 12.0805C17.7823 12.0953 17.73 12.0997 17.6785 12.0934C17.627 12.0872 17.5773 12.0704 17.5325 12.0442L15.625 10.9417L16.815 17.0783C16.8305 17.1589 16.8195 17.2422 16.7836 17.316C16.7477 17.3897 16.6888 17.4498 16.6159 17.4873C16.5429 17.5247 16.4598 17.5375 16.379 17.5237C16.2981 17.51 16.2239 17.4703 16.1675 17.4108L13.7 14.7625L13.0875 16.2033C13.053 16.2837 12.9917 16.3497 12.9141 16.3901C12.8365 16.4305 12.7473 16.4429 12.6617 16.425L9.5 15.7542L10.585 19.0908C10.6138 19.1786 10.6095 19.2739 10.5729 19.3587C10.5364 19.4436 10.4702 19.5122 10.3867 19.5517L9.15 20.1292L14.6392 24.5742C14.7006 24.6241 14.745 24.692 14.7659 24.7684C14.7868 24.8447 14.7833 24.9257 14.7558 25L14.0792 26.8667L19.09 25.9858C19.1717 25.9718 19.2555 25.9762 19.3352 25.9989C19.4149 26.0215 19.4886 26.0617 19.5507 26.1166C19.6128 26.1714 19.6619 26.2395 19.6942 26.3158C19.7265 26.3921 19.7413 26.4747 19.7375 26.5575L19.475 31.5917H20.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 31.5,
    width: 28,
    height: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: -1.5,
    width: 28,
    height: 11,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2375_4269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCad);
export default __webpack_public_path__ + "static/media/CAD.13e86914ecc729521e7435e042e187ce.svg";
export { ForwardRef as ReactComponent };